'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function Checkbox(_ref) {
  var action = _ref.action,
      id = _ref.id,
      title = _ref.title,
      checked = _ref.checked;
  return _react2.default.createElement(
    'span',
    { className: 'Checkbox' },
    _react2.default.createElement('input', { type: 'checkbox', id: id, checked: checked, onChange: action }),
    _react2.default.createElement(
      'label',
      { htmlFor: id },
      _react2.default.createElement(
        'span',
        { className: 'box ' + (checked && 'checked') },
        checked && _react2.default.createElement(_Icon2.default, { name: 'checkmark' })
      ),
      title
    )
  );
};

Checkbox.propTypes = {
  /** Action used as the onChange handler on the checkbox. */
  action: _propTypes2.default.func,
  /** Whether the checkbox is checked. */
  checked: _propTypes2.default.bool,
  /** The ID of the checkbox. */
  id: _propTypes2.default.string.isRequired,
  /** The title of the checkbox. */
  title: _propTypes2.default.string.isRequired
};

Checkbox.defaultProps = {
  action: null,
  checked: false
};

exports.default = Checkbox;
Checkbox.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Checkbox',
  'props': {
    'action': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Action used as the onChange handler on the checkbox.'
    },
    'checked': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the checkbox is checked.'
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The ID of the checkbox.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The title of the checkbox.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Checkbox.js
// module id = 583
// module chunks = 0